package com.nonopn.skywatcher.common.app.api.impl

import com.nonopn.skywatcher.common.app.api.Mode
import com.nonopn.skywatcher.common.app.pages.map.model.weather.AlertType
import com.nonopn.skywatcher.common.app.pages.map.model.weather.ProbeStatus
import com.nonopn.skywatcher.common.app.pages.sentinels.ThunderDetectionWithMetadata
import io.ktor.client.plugins.websocket.DefaultClientWebSocketSession
import kotlinx.serialization.Serializable

@Suppress("TooManyFunctions")
sealed interface ApiInterface {
    val mode: Mode

    suspend fun profile(): ApiLightUser

    suspend fun onPushNotificationToken(token: String)

    suspend fun status(thunderDetection: ThunderDetectionWithMetadata): ProbeStatus

    suspend fun detections(): List<ThunderDetectionWithMetadata>

    suspend fun users(thunderDetection: ThunderDetectionWithMetadata): ThunderDetectionUsers

    suspend fun registerDetectionUpdate(
        thunderDetection: ThunderDetectionWithMetadata,
        block: suspend DefaultClientWebSocketSession.() -> Unit
    )

    suspend fun confirmAlertSeen(thunderDetection: ThunderDetectionWithMetadata): ThunderDetectionSurroundingContext

    suspend fun sendManualAlert(
        thunderDetection: ThunderDetectionWithMetadata,
        alertType: AlertType
    ): ThunderDetectionSurroundingContext

    suspend fun surroundingUsers(thunderDetection: ThunderDetectionWithMetadata): ThunderDetectionSurroundingContext

    suspend fun addUser(
        thunderDetection: ThunderDetectionWithMetadata,
        email: String? = null,
        uuid: String? = null,
        isAdministrator: Boolean = false,
        validUntilSeconds: Long? = null,
    ): ThunderDetectionUsers

    suspend fun removeUser(
        thunderDetection: ThunderDetectionWithMetadata,
        user: ThunderDetectionUser
    ): ThunderDetectionUsers

    suspend fun updateLocation(location: ThunderDetectionLocation): ThunderDetectionLocation
}

object ApiInterfaceFake : ApiInterface {
    override val mode: Mode
        get() = Mode.Normal

    override suspend fun profile() = TODO("Not yet implemented")

    override suspend fun onPushNotificationToken(token: String) = TODO("Not yet implemented")

    override suspend fun status(thunderDetection: ThunderDetectionWithMetadata) =
        TODO("Not yet implemented")

    override suspend fun detections() = TODO("Not Yet Implemented")

    override suspend fun users(thunderDetection: ThunderDetectionWithMetadata) =
        TODO("Not yet implemented")

    override suspend fun registerDetectionUpdate(
        thunderDetection: ThunderDetectionWithMetadata,
        block: suspend DefaultClientWebSocketSession.() -> Unit
    ) = TODO("Not yet implemented")

    override suspend fun confirmAlertSeen(thunderDetection: ThunderDetectionWithMetadata) =
        TODO("Not yet implemented")

    override suspend fun sendManualAlert(
        thunderDetection: ThunderDetectionWithMetadata,
        alertType: AlertType
    ) = TODO("Not yet implemented")

    override suspend fun surroundingUsers(thunderDetection: ThunderDetectionWithMetadata) =
        TODO("Not yet implemented")

    override suspend fun addUser(
        thunderDetection: ThunderDetectionWithMetadata,
        email: String?,
        uuid: String?,
        isAdministrator: Boolean,
        validUntilSeconds: Long?,
    ) = TODO("Not yet implemented")

    override suspend fun removeUser(
        thunderDetection: ThunderDetectionWithMetadata,
        user: ThunderDetectionUser
    ) = TODO("Not yet implemented")

    override suspend fun updateLocation(location: ThunderDetectionLocation) =
        TODO("Not yet implemented")
}


@Serializable
data class ThunderDetectionAddUser(
    val email: String?,
    val uuid: String?,
    val isAdministrator: Boolean = false,
    val validUntilSeconds: Long? = null,
)

@Serializable
data class ThunderDetectionUser(
    val uuid: String,
    val email: String,
    val isAdministrator: Boolean,
    val isOwner: Boolean,
    val validUntilSeconds: Long? = null,
)

@Serializable
data class ThunderDetectionUsers(
    val canInvite: Boolean,
    val users: List<ThunderDetectionUser>,
)

@Serializable
data class ApiLightUser(
    val uuid: String
)

@Serializable
data class ThunderDetectionLocation(
    val latitude: Double? = null,
    val longitude: Double? = null
)

@Serializable
data class ThunderDetectionSurroundingContext(
    val users: List<ThunderDetectionSurroundingUser> = emptyList(),
    val current: ThunderDetectionSurroundingUser? = null
)

@Serializable
data class PushNotificationTokenPost(
    val token: String,
    val app: String
)

@Serializable
data class ThunderDetectionSurroundingUser(
    val id: String,
    val latitude: Double,
    val longitude: Double,
    val alertState: WarnStateValidationState
)


@Serializable
enum class WarnStateValidationState {
    AllClear,
    NeedsConfirm,
    Confirmed
}